export const state = {
	previewModal: false
};

export const getters = {
	modalState: (state): boolean => state.previewModal as boolean
};

export const mutations = {
	modalState(state, active) {
		state.previewModal = active;
	}
};

export default { namespaced: true, state, getters, mutations };
